// src/api/teamApi.js
import { apiClient, getAuthHeader } from "./apiConfig";
export const fetchTeams = async (params = {}) => {
  const res = await apiClient.get(`/teams/get_all`, {
    ...getAuthHeader(),
    params,
  });
  return res.data?.data || [];
};

export const createTeam = async (payload) => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) formData.append(k, v);
  });

  return await apiClient.post(`/teams/create`, formData, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
};
export const updateTeam = async (id, payload) => {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) formData.append(k, v);
  });

  return await apiClient.post(`/teams/update/${id}`, formData, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteTeam = async (id) => {
  return await apiClient.delete(`/teams/delete/${id}`, getAuthHeader());
};
